import { COLORS } from '@btime/constants'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import Container from '../../../components/structure/Container'
import ControlledModal from '../../../components/modals/ControlledModal'
import ModalHeader from './ModalHeader'
import PermissionChecker from '../../session/_shared/PermissionChecker'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TemplatesList from './TemplatesList'

const TemplatesSugestionsModal = props => {
  return (
    <ControlledModal fullScreen {...props}>
      <PermissionChecker name={'createTrigger'}>
        <ModalHeader />

        <HorizontalLine thin lineColor={COLORS.light2} />
        <Separator weight={4} />

        <Container maxWidth="68rem">
          <TemplatesList />
        </Container>
      </PermissionChecker>
    </ControlledModal>
  )
}

export default TemplatesSugestionsModal
